module.exports = __webpack_public_path__ + "img/programme7.35109c47.png";